
/**
 * (see `flowCanvas/hooks/useReactFlowOnMove` for more info)
 * These constants allow fine control of the debouncing behavior. A lot of trial and error led to
 * these amounts. If tweaking them, ON_MOVE_END_DEBOUNCE_TIME and ON_MOVE_START_DEBOUNCE_TIME
 * should stay relatively close to each other, and ON_MOVE_START_DEBOUNCE_TIME should be smaller
 * than ON_MOVE_END_DEBOUNCE_TIME.
 * More info on how debouncing events work: https://css-tricks.com/debouncing-throttling-explained-examples/
 */
export const ON_MOVE_END_DEBOUNCE_TIME = 60;
export const ON_MOVE_START_DEBOUNCE_TIME = 50;
export const ON_RESIZE_DEBOUNCE_TIME = 100;
